/* eslint-disable no-unused-expressions */
import axios from "axios"
import normalize from "json-api-normalizer"
import _ from "lodash"

export const getBrandByIdentifier = (baseUrl, identifier) => {
  const path = `${baseUrl}/brands/${identifier}`

  return axios.get(path, {})
    .then(({ data, status }) => ({ response: normalize(data), status }))
    .catch(error => { error })
}

export const getBrands = (baseUrl, data = {}) => {
  const path = `${baseUrl}/brands`
  return axios.get(path, { params: data })
    .then(({ data, status }) => ({
      response: {
        data: normalize(data),
        ids: _.get(data, "meta.order", [])
      },
      status
    }))
    .catch(error => { error })
}

export const getOrderedTopBrands = (baseUrl, data = {}) => {
  const path = `${baseUrl}/top_lists/brands`

  return axios.get(path, { params: data })
    .then(({ data, status }) => ({
      response: {
        data: normalize(data),
        ids: _.get(data, "meta.order", [])
      },
      status
    }))
    .catch(error => { error })
}
